import {EntityService} from '../EntityService';

export class TemplateInvoiceService extends EntityService {

  static entity = 'api/app/template-security';

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}`).then(res => res.data);
  }
  static update(id,data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/security`,data).then(res => res.data);
  }
  static getTemplate(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/security`).then(res => res.data);
  }
  static getHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/html/${id}`).then(res => res.data);
  }

  static getImagePreview(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/image-preview/${id}`, {responseType: 'blob'}).then(res => res.data);
  }

}
